import { getTransformer } from "@nova/transformers"
import { Coordinate3D } from "@nova/constants"
import store from "integrations/redux/store"

// using getters instead of hooks because the project would be a dependency of the hook

export const getInfraredFlightTransformer = (flightId: string) => {
    const state = store.getState()
    return getTransformer(state.project.data).infraredFlight(flightId)
}

export const getOrthoFlightTransformer = (flightId: string) => {
    const state = store.getState()
    return getTransformer(state.project.data).orthoFlight(flightId)
}

export const getLiveVideoFlightTransformer = (flightId: string, events: Coordinate3D[]) => {
    const state = store.getState()
    return getTransformer(state.project.data).liveVideoFlight(flightId, events)
}
